var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 137 137"
    },
    xmlSpace: "preserve",
    viewBox: "32.35 38.27 72.28 60.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stWhite{fill:#FFFFFF;stroke-width: 2}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hintergrund"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "stWhite",
    d: "M95.6,41.5L95.6,41.5c1.6,0,3,0.6,4.1,1.7c2.3,2.3,2.3,6,0,8.3L57.2,94.2l-20-20c-1.1-1.1-1.7-2.6-1.7-4.1    c0-1.6,0.6-3,1.7-4.2c1.1-1.1,2.6-1.7,4.1-1.7c1.6,0,3,0.6,4.1,1.7L57,77.5l34.3-34.3C92.6,42.1,94.1,41.5,95.6,41.5 M95.6,38.3    c-2.3,0-4.6,0.9-6.4,2.7l-32,32l-9.4-9.4C46,61.9,43.7,61,41.4,61s-4.6,0.9-6.4,2.7l0,0c-3.5,3.5-3.5,9.3,0,12.8l22.2,22.2    L102,53.8c3.5-3.5,3.5-9.3,0-12.8C100.3,39.2,97.9,38.3,95.6,38.3L95.6,38.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/Icon_Check.da3aa8786ab24eef5a7c83ac8c6015b9.svg";
export { ForwardRef as ReactComponent };